import React from "react";
import { motion } from "framer-motion";
import { sentence, letter } from "../assets/js/animations";

const SectionHeading = ({ sectiontitle, sectiontitle2, textAlign }) => {
  return (
    <>
      <motion.h2
        className={`section-header-title ${textAlign}`}
        variants={sentence}
        initial="initial"
        whileInView="animate"
      >
        {sectiontitle.split("").map((char, key) => {
          return (
            <motion.span key={`${char}+${key}`} variants={letter}>
              {char}
            </motion.span>
          );
        })}
        {sectiontitle2 && " "}
        {sectiontitle2 &&
          sectiontitle2.split("").map((char, key) => {
            return (
              <motion.span key={`${char}+${key}`} variants={letter}>
                {char}
              </motion.span>
            );
          })}
      </motion.h2>
    </>
  );
};

export default SectionHeading;
